import { msg } from '../messages'
import * as Util from '../util'

const INTEGER_ONLY = /^[0-9]+$/

export function range(min: number, max: number, integerOnly: boolean = false) {
  return (value: number) => {
    return (
      validateFormat(value, integerOnly) ||
      (!Util.isEmpty(value) && (value < min || value > max) ? msg('range', value, min, max) : null)
    )
  }
}

export function minRange(min: number, integerOnly: boolean = false) {
  return (value: number) => {
    return (
      validateFormat(value, integerOnly) || (!Util.isEmpty(value) && value < min ? msg('minRange', value, min) : null)
    )
  }
}

export function maxRange(max: number, integerOnly: boolean = false) {
  return (value: number) => {
    return (
      validateFormat(value, integerOnly) || (!Util.isEmpty(value) && value > max ? msg('maxRange', value, max) : null)
    )
  }
}

function validateFormat(value: number, integerOnly: boolean) {
  if (value && isNaN(value)) {
    return msg('NaN')
  } else if (value && integerOnly && !new RegExp(INTEGER_ONLY).test(value.toString())) {
    return msg('match')
  }
}
